import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/components/app.component';
import { register as registerSwiper } from 'swiper/element/bundle';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err)).then(() => {
  registerSwiper();
});
